import {styled} from '../index';
import {Button} from './components';


export const ContainedButton = styled(Button)`
    ${({ theme }) => theme.typography.button};
    color: white;
    background: ${({ theme }) => theme.palette.primary.main};
    :hover {
        background-color: ${({ theme }) => theme.palette.primary.dark};
    }
    :disabled {
        color: rgba(0, 0, 0, 0.26);
        background-color: rgba(0, 0, 0, 0.12);
        box-shadow: none;
        pointer-events: none;
    }
`;

export const BackBtnWithDarkTheme = styled(Button)`
    ${({ theme }) => theme.typography.button};
    color:#90CAF9;
    &:hover{
       background: var(--dark-primary-shades-8-p, rgba(144, 202, 249, 0.08));;
    }
`;

export const ButtonWithDarkTheme = styled(Button)`
    ${({theme}) => theme.typography.button};
    background: #90CAF9;
    color: black;

    :hover {
        background-color: #42A5F5;
    }

    &:disabled {
        background-color: rgb(54, 54, 54);
        color: rgba(255, 255, 255, 0.3)

    }
`;
